export function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  };
}

export function brightness(hex) {
  const rgb = hexToRgb(hex);
  return Math.sqrt(
    0.3 * (rgb.r * rgb.r) +
    0.6 * (rgb.g * rgb.g) +
    0.1 * (rgb.b * rgb.b)
  );
}
